"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'shopDetail',
  props: {
    shopInfo: {
      type: Object,
      default: null
    },
    keyUrl: {
      type: String,
      default: 'https://apis.map.qq.com/tools/locpicker?type=1&key=SMJBZ-WCHK4-ZPZUA-DSIXI-XDDVQ-XWFX7&referer=myapp'
    }
  },
  data: function data() {
    return {
      direction: 'rtl',
      dialogVisible: false,
      loading: false,
      dialogFormVisible: false
    };
  },
  watch: {},
  mounted: function mounted() {},
  methods: {
    handleClose: function handleClose() {
      this.dialogVisible = false;
    }
  }
};